import { Recipe } from 'common/hooks/useProducer';
import {
  AcceptTermsAndConditionsState,
  CustomerOutstandingsState,
  CustomerState,
  CustomerSummariesState,
  TermsAndConditionsState,
  WhitelabelAccountsState,
} from './states';
import {
  AcceptTermsAndConditionsActions,
  CurrencyConvertActions,
  CustomerActions,
  CustomerOutstandingsActions,
  CustomerSummariesActions,
  ReconcileCustomerActions,
  SettleCustomerActions,
  TermsAndConditionsActions,
  WhitelabelAccountsActions,
} from './actions';
import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import { APIRequestState } from 'api';

// #region CustomerSummary
export const customerSummariesRecipe: Recipe<
  CustomerSummariesState,
  CustomerSummariesActions
> = (draft, action) => {
  switch (action.type) {
    case 'customers/summaries/started':
      draft.pending = true;
      return;

    case 'customers/summaries/finished':
      draft.pending = false;
      // This action is run twice, one time including `outstanding` numbers,
      // and one time without. Sometimes, due to caching, the order can be flipped,
      // so only update state if the new data contains `outstanding` numbers.
      if (draft.summaries === null || action.summaries?.filter(s => s.balances.outstanding).length > 0) {
        draft.summaries = action.summaries;
      }
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region Customer
export const customerRecipe: Recipe<CustomerState, CustomerActions> = (
  draft,
  action
) => {
  switch (action.type) {
    case 'customer/started':
      draft.pending = true;
      return;

    case 'customer/finished':
      draft.pending = false;
      draft.customer = action.customer;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const customerOutstandingsRecipe: Recipe<
  CustomerOutstandingsState,
  CustomerOutstandingsActions
> = (draft, action) => {
  switch (action.type) {
    case 'customers/outstandings/started':
      draft.pending = true;
      return;

    case 'customers/outstandings/finished':
      draft.pending = false;
      draft.outstandings = action.outstandings;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const settleCustomerRecipe: Recipe<
  APIRequestState,
  SettleCustomerActions
> = (draft, action) => {
  switch (action.type) {
    case 'customers/settle/started':
      draft.pending = true;
      return;

    case 'customers/settle/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const reconcileCustomerRecipe: Recipe<
  APIRequestState,
  ReconcileCustomerActions
> = (draft, action) => {
  switch (action.type) {
    case 'customers/reconcile/started':
      draft.pending = true;
      return;

    case 'customers/reconcile/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const currencyConvertRecipe: Recipe<
  APIRequestState,
  CurrencyConvertActions
> = (draft, action) => {
  switch (action.type) {
    case 'customers/currency_convert/started':
      draft.pending = true;
      return;

    case 'customers/currency_convert/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region WhitelabelAccount
export const whitelabelAccountsRecipe: Recipe<
  WhitelabelAccountsState,
  WhitelabelAccountsActions
> = (draft, action) => {
  switch (action.type) {
    case 'whitelabels/accounts/started':
      draft.pending = true;
      return;

    case 'whitelabels/accounts/finished':
      draft.pending = false;
      draft.accounts = action.accounts;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region TermsAndConditions
export const termsAndConditionsRecipe: Recipe<
  TermsAndConditionsState,
  TermsAndConditionsActions
> = (draft, action) => {
  switch (action.type) {
    case 'terms/started':
      draft.pending = true;
      return;

    case 'terms/finished':
      draft.pending = false;
      draft.tncs = action.tncs;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
export const acceptTermsAndConditionsRecipe: Recipe<
  AcceptTermsAndConditionsState,
  AcceptTermsAndConditionsActions
> = (draft, action) => {
  switch (action.type) {
    case 'terms/accept/started':
      draft.pending = true;
      return;

    case 'terms/accept/finished':
      draft.pending = false;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion
